// @ts-nocheck
/* eslint-disable */
import { CLEAR_SCRAPER_DATA, CLEAR_ERRORS } from '../actions/StartActions';
import { FETCH_APP_INFO } from '../../main/actions/ScraperAction';

const onboarding = (state = {}, action) => {
  switch (action.type) {
    case FETCH_APP_INFO.response:
      return {
        ...state,
        scraperData: action.data.app_data,
      };

    case FETCH_APP_INFO.error:
      return {
        ...state,
        errors: action.error,
      };

    case CLEAR_SCRAPER_DATA:
      return {
        ...state,
        scraperData: {},
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        errors: {},
      };

    default:
      return state;
  }
};

export default onboarding;
